module.exports = __webpack_public_path__ + "static/media/closeSearch.61a32cc9.svg";